export default __webpack_public_path__ + "static/suggestion-7a5125c9ff62588231c19b2db5211958.webp";